<template>
    <div>
        <h4 v-if="this.data.title">{{ this.data.title }}</h4>
        <ul>
            <li v-for="item in this.data.report">
                <span v-html="item.label"></span>
                <ListReport v-if="item.children" :data="formatDataForRecursiveChildComponent(item.children)"></ListReport>
            </li>
        </ul>
    </div>
</template>

<script>
  import ReportFormatter from '@/services/report_formatter'

  export default {
    name: 'ListReport',
    props: ['data'],
    methods: {
      formatDataForRecursiveChildComponent (data) {
        return ReportFormatter.textual(data)
      }
    }
  }
</script>

<style scoped>
  h4, li {
    color: #333;
  }
  li {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// ListReport.vue?2ffc13d6